import React, { useState, useMemo } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import CountUp from "react-countup";
import { CurrencySymbol, PaymentType, UserType } from "../../../utils/enum";
import AddEditBillingRatesModal from "./components/AddEditBillingRatesModal";

const AddEditBillingRates = ({ readOnly = false, billingRates, authRole, userData, refetchMe }) => {
  const [isBillingRatesOpen, setIsBillingRatesOpen] = useState(false);

  const handleOpen = () => setIsBillingRatesOpen(true);
  const handleClose = () => setIsBillingRatesOpen(false);

  /* const modalBillingRates = useMemo(() => {
    if (!billingRates || billingRates.length === 0) return [];

    const currencies = [...new Set(billingRates.map((r) => r.currency))];

    if (currencies.length === 1) {
      return billingRates;
    } else {
      const firstCurrency = billingRates[0].currency;
      const ratesForFirstCurrency = billingRates.filter((r) => r.currency === firstCurrency);

      const allPaymentTypes = ["HOURLY", "HALF_DAY", "FULL_DAY"];

      return allPaymentTypes.map((pt) => {
        const rateObj = ratesForFirstCurrency.find((r) => r.paymentType === pt);
        return {
          paymentType: pt,
          currency: firstCurrency,
          rate: rateObj ? rateObj.rate : "",
        };
      });
    }
  }, [billingRates]); */

  const formattedBillingRates = useMemo(() => {
    if (!billingRates || billingRates?.length === 0) return [];

    const firstCurrency = billingRates[0]?.currency;

    const allPaymentTypes = ["HOURLY", "HALF_DAY", "FULL_DAY"];

    return allPaymentTypes.map((type) => {
      const existing = billingRates.find(
        (r) => r.paymentType === type && r.currency === firstCurrency,
      );

      return {
        paymentType: type,
        currency: firstCurrency,
        rate: existing?.rate ?? 0,
      };
    });
  }, [billingRates]);

  return (
    <BaseCard className="py-2 px-4 sm:px-6 rounded-lg" elevation={1}>
      <div className="bg-light px-4 py-2 mt-2 mb-2 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Billing Rates</h6>
        {readOnly ? null : authRole === UserType.ADMIN ? (
          <i className="fa-light fa-pencil text-gray-900 cursor-pointer" onClick={handleOpen}></i>
        ) : (
          <p className="col-span-3 text-right text-sm">
            <span className="text-primary">Contact Support</span> to change the Billing rates
          </p>
        )}
      </div>

      <div className="mt-12 mb-8 px-4">
        {formattedBillingRates && formattedBillingRates.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-6 lg:gap-12">
            {formattedBillingRates.map((rate) => (
              <div
                key={`${rate.currency}-${rate.paymentType}`}
                className="border rounded-lg px-4 py-2 cursor-pointer group hover:bg-primary transition-colors duration-300"
              >
                <h1 className="text-center font-normal text-primary pt-12 pb-6 group-hover:text-white">
                  <CountUp start={0} end={rate?.rate || 0} duration={2} separator="," />{" "}
                  {CurrencySymbol[rate?.currency] ?? rate?.currency}{" "}
                  <span className="text-xs text-[#686868] group-hover:text-white">
                    {PaymentType[rate?.paymentType]}
                  </span>
                </h1>
                <p className="text-primary font-normal group-hover:text-white">
                  Currency:{" "}
                  <span className="text-[#686868] group-hover:text-white">{rate?.currency}</span>
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-sm text-gray-400 italic">No billing rates available</p>
        )}
      </div>

      {isBillingRatesOpen && (
        <AddEditBillingRatesModal
          open={isBillingRatesOpen}
          close={handleClose}
          userBillingRates={formattedBillingRates}
          refetchMe={refetchMe}
          userId={userData?.id}
          authRole={authRole}
          address={userData?.personalAddress}
        />
      )}
    </BaseCard>
  );
};

export default AddEditBillingRates;
